import { ReCaptchaProvider } from 'next-recaptcha-v3';

import { env } from '@natu/env';

import { StoryblokRichtext, StoryblokRichTextData } from '../../../../../richtext';
import { sbEditable, SBProps } from '../../../../../utils';
import { GetAnEstimateFormContent } from './GetAnEstimateFormContent';

interface SBGetAnEstimateFormProps {
  formTitleTag?: 'h1' | 'h2' | 'h3';
  formTitle?: string;
  privacyNote?: StoryblokRichTextData;
  marketingNote?: string;
  errorMessage?: string;
  sendEvent?: boolean;
  event_form_name?: string;
  event_internal_campaign_name?: string;
}

export const SBGetAnEstimateForm = ({ blok }: SBProps<SBGetAnEstimateFormProps>) => {
  const {
    formTitleTag,
    formTitle,
    privacyNote,
    marketingNote,
    errorMessage,
    sendEvent,
    event_form_name,
    event_internal_campaign_name,
  } = blok;

  return (
    <ReCaptchaProvider reCaptchaKey={env.RECAPTCHA_SITE_KEY}>
      <GetAnEstimateFormContent
        formTitleTag={formTitleTag}
        formTitle={formTitle}
        privacyNote={
          <StoryblokRichtext className="text-xs leading-[1.3] opacity-80" data={privacyNote} />
        }
        marketingNote={marketingNote}
        errorMessage={errorMessage}
        sendEvent={sendEvent}
        event_form_name={event_form_name}
        event_internal_campaign_name={event_internal_campaign_name}
        {...sbEditable(blok)}
      />
    </ReCaptchaProvider>
  );
};
